import { Component, OnInit, Inject } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material'
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms'
import { ErrorsService } from 'src/app/core/services/errors.service'
interface DialogData {
  cnpj: string
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal-closings.component.html',
  styleUrls: ['./modal-closings.component.scss'],
})
export class ModalIntegrationsClosingsComponent implements OnInit {
  public formGroup: FormGroup

  constructor (
    public dialogRef: MatDialogRef<ModalIntegrationsClosingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private readonly formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public errorsService: ErrorsService,
  ) {
    console.log('data', data)
  }

  cancel (): void {
    this.dialogRef.close('cancel')
  }

  submit () {
    if (!this.formGroup.valid) {
      this.snackBar.open('Preencha corretamente os campos e tente novamente.')
      return false
    }

    this.dialogRef.close(this.formGroup.value)
  }

  ngOnInit () {
    this.formGroup = this.formBuilder.group({
      startDate: [null, [Validators.required]],
      dateEnd: [null, [Validators.required]],
      // paymentDate: [null, [Validators.required]],
    })
  }
}
